export default __webpack_public_path__ + "static/media/openMessages.svg";